import React from 'react';

const SiteMapSection = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div className="bg-white p-6 rounded-xl shadow-sm border border-[#172A45]/10">
    <h3 className="text-[#0A192F] font-medium mb-4 text-lg border-b border-[#64FFDA] pb-2">
      {title}
    </h3>
    <ul className="space-y-3 text-sm">
      {children}
    </ul>
  </div>
);

const SystemBadges = () => (
  <div className="mt-4 flex justify-center gap-4">
    <span className="px-3 py-1 bg-[#64FFDA]/10 text-[#64FFDA] rounded-full">PCI Compliant</span>
    <span className="px-3 py-1 bg-[#64FFDA]/10 text-[#64FFDA] rounded-full">SSL Secure</span>
    <span className="px-3 py-1 bg-[#64FFDA]/10 text-[#64FFDA] rounded-full">DMCA Protected</span>
  </div>
);

export const SiteMap = () => {
  return (
    <div className="bg-[#F8FAFC] min-h-screen py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-3xl font-bold text-[#6D28D9] mb-4">
            TemplateHub Navigation Matrix
          </h1>
          <p className="text-[#4B5563] max-w-2xl mx-auto">
            Structured access to our digital asset ecosystem and creator resources
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {/* Marketplace Navigation */}
          <SiteMapSection title="Marketplace Core">
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/marketplace">All Assets</a>
            </li>
            <li className="ml-4 text-[#4B5563]">
              - Design Templates
              <br />
              - Graphic Packs
              <br />
              - UI Kits
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/categories">Categories</a>
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/featured">Featured Products</a>
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/new">New Arrivals</a>
            </li>
          </SiteMapSection>

          {/* Creator Ecosystem */}
          <SiteMapSection title="Creator Ecosystem">
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/upload">Upload Assets</a>
            </li>
            <li className="ml-4 text-[#4B5563]">
              - Submission Guidelines
              <br />
              - Royalty Structure
              <br />
              - Quality Standards
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/dashboard">Creator Dashboard</a>
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/collaborate">Collaboration Hub</a>
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/licensing">Licensing Models</a>
            </li>
          </SiteMapSection>

          {/* Resource Hub */}
          <SiteMapSection title="Resource Hub">
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/blog">Design Insights</a>
            </li>
            <li className="ml-4 text-[#4B5563]">
              - Tutorials
              <br />
              - Industry Trends
              <br />
              - Case Studies
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/tools">Design Tools</a>
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/fonts">Font Library</a>
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/licenses">License Manager</a>
            </li>
          </SiteMapSection>

          {/* Support & Legal */}
          <SiteMapSection title="Support Network">
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/support">Help Center</a>
            </li>
            <li className="ml-4 text-[#4B5563]">
              - Technical Support
              <br />
              - Asset Refunds
              <br />
              - Account Issues
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/legal">Usage Rights</a>
            </li>
            <li className="ml-4 text-[#4B5563]">
              - Commercial Licenses
              <br />
              - Copyright FAQ
              <br />
              - Trademark Policy
            </li>
            <li className="text-[#6D28D9] hover:text-[#8B5CF6] transition-colors">
              <a href="/affiliate">Affiliate Program</a>
            </li>
          </SiteMapSection>
        </div>

        <div className="mt-12 text-center text-sm text-[#4B5563]">
          <p>Marketplace Version 4.2 | Content API v2.1.3</p>
          <SystemBadges />
          <div className="mt-6 flex justify-center gap-6">
            <a href="/sitemap.xml" className="text-[#6D28D9] hover:text-[#8B5CF6]">XML Sitemap</a>
            <a href="/robots.txt" className="text-[#6D28D9] hover:text-[#8B5CF6]">Robots.txt</a>
            <a href="/status" className="text-[#6D28D9] hover:text-[#8B5CF6]">System Status</a>
          </div>
        </div>
      </div>
    </div>
  );
};